<template>
  <div>
    <v-dialog v-model="documentDialog" max-width="992px" lazy>
      <v-card class="pa-3">
        <v-card-title class="py-2">
          <v-layout align-center justify-end row fill-height>
            <div class="headline font-weight-bold mx-auto">
              Documentos do membro
            </div>
          </v-layout>
          <v-icon @click="documentDialog = false" class="ml-auto" color="orange"
            >mdi-close</v-icon
          >
        </v-card-title>
        <v-card-text class="ma-0 pa-0">
          <v-layout row wrap v-if="documents?.length > 0">
            <v-flex
              sm12
              md3
              class="ma-0 pa-0"
              v-for="(photo, i) in documents"
              :key="i"
            >
              <v-card class="mb-2 mx-1 pa-1">
                <v-card-title class="title pa-0 my-0">
                  <v-layout row wrap>
                    <v-flex px-1 pb-0 md12>
                      <a
                        :href="photo.url"
                        target="_blank"
                        style="color: #000"
                        class="doc"
                        >{{ formatPhotoTittle(photo.type) }}</a
                      >
                    </v-flex>
                    <v-flex px-1 pt-0 md12 class="caption">
                      <div class="text-truncate">
                        <a
                          :href="photo.url"
                          target="_blank"
                          style="color: #000"
                          class="doc"
                          >{{ photo.name }}</a
                        >
                      </div>
                    </v-flex>
                  </v-layout>
                </v-card-title>
                <a
                  :href="photo.url"
                  target="_blank"
                  style="color: #000"
                  class="doc"
                >
                  <v-img
                    v-if="isImage(photo.name)"
                    :src="photo.url"
                    :contain="true"
                    class="d-flex"
                  ></v-img>
                  <pdf v-if="isPdf(photo.name)" :src="photo.url"></pdf>
                </a>
              </v-card>
            </v-flex>
          </v-layout>
          <p v-else class="py-2 text-md-center">
            O membro não possui documentos
          </p>
        </v-card-text>
        <v-card-actions>
          <div class="ml-auto">
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn color="primary" text v-on="on" :disabled="loadingUpload">
                  <v-progress-circular
                    v-if="loadingUpload"
                    indeterminate
                    color="white"
                    size="18"
                    class="mr-2"
                  >
                  </v-progress-circular>
                  <v-icon v-else class="mr-2">mdi-upload</v-icon>Adicionar
                  documento
                </v-btn>
              </template>
              <v-list>
                <v-list-tile
                  v-for="(item, index) in categories"
                  :key="index"
                  @click="pickIdPhoto(item)"
                >
                  <v-list-tile-title>{{ item.name }}</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="confirmOverwriteDialog" persistent max-width="400">
      <v-card class="py-3 px-1">
        <v-card-title>
          <div class="title font-weight-bold text-xs-center">
            O arquivo {{ docToDelete }} já existe, tem certeza que deseja
            sobrescrever?
          </div>
        </v-card-title>
        <v-card-actions>
          <div class="mx-auto">
            <v-btn color="primary" text @click="cancelOverwrite()"
              >Cancelar</v-btn
            >
            <v-btn color="pink darken-1" text @click="confirmOverwrite()"
              >Confirmar</v-btn
            >
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar :color="color" top v-model="snackbar" dark>
      <v-icon color="white" class="mr-3"> mdi-bell-plus </v-icon>
      <div>{{ snackMessage }}</div>
      <v-icon size="16" @click="snackbar = false"> mdi-close-circle </v-icon>
    </v-snackbar>
    <input
      accept="application/pdf,image/*"
      type="file"
      ref="idPhoto"
      style="display: none"
      @change="pickedPhotos($event)"
      :key="docKey"
    />
  </div>
</template>

<script>
import { uploadData } from "../../../services/sales";
import { mapState, mapActions, mapGetters } from "vuex";
import pdf from "vue-pdf";

export default {
  components: {
    pdf,
  },
  data() {
    return {
      user: null,
      idPhoto: [
        {
          name: "",
          data: null,
        },
      ],
      id_photo: "",
      documentDialog: false,
      categoryDialog: false,
      confirmOverwriteDialog: false,
      category: null,
      categories_pf: [
        { type: "document_back", name: "Documento Verso" },
        { type: "document_front", name: "Documento Frente" },
        { type: "document_front_and_back", name: "Documento Frente e Verso" },
        { type: "selfie_with_document", name: "Selfie com Documento" },
        { type: "energy_bill", name: "Conta de Luz" },
        { type: "others", name: "Outros" },
      ],
      categories_pj: [
        {
          type: "proof_of_social_responsibility",
          name: "Comprovante de Responsabilidade Social",
        },
        { type: "document_back", name: "Documento Verso" },
        { type: "document_front", name: "Documento Frente" },
        { type: "document_front_and_back", name: "Documento Frente e Verso" },
        { type: "selfie_with_document", name: "Selfie com Documento" },
        { type: "letter_of_attorney", name: "Procuração" },
        { type: "energy_bill", name: "Conta de Luz" },
        { type: "others", name: "Outros" },
      ],
      color: "",
      snackMessage: "",
      snackbar: false,
      loadingUpload: false,
      loadingDelete: false,
      photo_origin: null,
      names: {
        id_card_photo_1: "Documento Frente",
        id_card_photo_2: "Documento Verso",
        id_card_selfie: "Selfie com Documento",
      },
      docToDelete: null,
      docKey: 0,
    };
  },
  computed: {
    ...mapState("cs", ["documents"]),
    ...mapGetters(["loggedUser"]),
    formatPhotoName() {
      return (photo) => {
        return this.names[photo] ? this.names[photo] : photo;
      };
    },
    categories() {
      return this.user?.person_type === "pj"
        ? this.categories_pj
        : this.categories_pf;
    },
    selectedDoc() {
      if (this.category?.type == "document_back") return "Documento Verso";
      else if (this.category?.type == "document_front")
        return "Documento Frente";
      else if (this.category?.type == "document_front_and_back")
        return "Documento Frente e Verso";
      else if (this.category?.type == "others") return "Outros";
      else if (this.category?.type == "selfie_with_document")
        return "Selfie com Documento";
      else if (this.category?.type == "proof_of_social_responsibility")
        return "Comprovante de Responsabilidade Social";
      else if (this.category?.type == "letter_of_attorney") return "Procuração";
      else if (this.category?.type == "energy_bill") return "Conta de Luz";
      else return "";
    },
  },
  methods: {
    ...mapActions("cs", ["getIdPhotos"]),

    formatPhotoTittle(type) {
      return this.categories.find((item) => item.type == type)?.name;
    },

    async showDocumentModal(user) {
      await this.getIdPhotos(user?.customer_id);
      this.user = user;
      this.documentDialog = true;
    },
    pickIdPhoto(category) {
      if (!category) {
        this.snack("Selecione uma categoria para o documento!", "red");
        return;
      }
      this.category = category;
      this.$refs.idPhoto.click();
    },
    async pickedPhotos(event) {
      this.loadingUpload = true;
      const photoFile = event.target.files;

      let category = { ...this.category };

      this.docKey++;
      this.documentDialog = true;
      this.idPhoto = [
        {
          category,
          data: photoFile[0],
        },
      ];

      const documentFound = this.documents?.find(
        (item) => item.name == photoFile[0].name,
      );
      if (documentFound) {
        this.docToDelete = documentFound.name;
        this.confirmOverwriteDialog = true;
        this.loadingUpload = false;
        return;
      }

      try {
        await uploadData({
          id: this.user?.customer_id,
          data: this.idPhoto,
          agent_email: this.loggedUser?.email,
        });
        await this.getIdPhotos(this.user?.customer_id);
        this.snack("Arquivo anexado com sucesso.", "green");
      } catch {
        this.snack("Erro ao anexar arquivo, tente novamente!", "red");
      }
      this.loadingUpload = false;
    },
    async replaceEnergyBill() {
      this.loadingUpload = true;
      try {
        await uploadData({
          id: this.user?.customer_id,
          data: this.idPhoto,
          agent_email: this.loggedUser?.email,
        });
        await this.getIdPhotos(this.user?.customer_id);
        this.snack("Arquivo anexado com sucesso.", "green");
      } catch {
        this.snack("Erro ao anexar arquivo, tente novamente!", "red");
      }
      this.loadingUpload = false;
    },
    cancelOverwrite() {
      this.category = null;
      this.confirmOverwriteDialog = false;
      this.docToDelete = null;
      this.idPhoto = null;
    },
    confirmOverwrite() {
      this.replaceEnergyBill();
      this.confirmOverwriteDialog = false;
      this.docToDelete = null;
    },
    snack(message, color) {
      this.color = color;
      this.snackMessage = message;
      this.snackbar = true;
    },
    isImage(fileName) {
      const imageTypes = ["jpg", "jpeg", "png"];
      return imageTypes.includes(fileName.split(".").pop().toLowerCase());
    },
    isPdf(fileName) {
      return fileName.split(".").pop().toLowerCase() === "pdf";
    },
  },
};
</script>

<style scoped lang="scss">
.doc {
  transition: 0.4s;
  &:hover {
    opacity: 0.8 !important;
  }
}
</style>
